import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type {
  RegisterForm,
  RegisterVo,
  VerifyCodeQuery,
  ForgetPasswordQuery,
  ForgetUpdatePasswordQuery,
  TrafficSourceRequest,
  TrafficSourceVo
} from './types.ts';

/**
 * 注册
 **/
export const register = (data: RegisterForm): AxiosPromise<RegisterVo> => {
  return request({
    url: '/member/auth/signup',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};

/**
 * 发送邮箱、手机验证码
 **/
export const verifyCode = (data: VerifyCodeQuery) => {
  return request({
    url: '/member/auth/verifyCode',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};

/**
 * 忘记密码发送邮件
 */
export const forgetPassword = (data: ForgetPasswordQuery) => {
  return request({
    url: '/member/auth/forgetPassword',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};

/**
 * 忘记密码更新密码
 */
export const forgetUpdatePassword = (data: ForgetUpdatePasswordQuery) => {
  return request({
    url: '/member/auth/updatePassword',
    headers: {
      isEncrypt: true
    },
    method: 'post',
    data
  });
};

// 保存网站流量来源
// POST /member/auth/saveTraffic
// 接口ID：303079062
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-303079062
export const postSaveTraffic = (data: TrafficSourceRequest): AxiosPromise<TrafficSourceVo> => {
  return request({
    url: '/member/auth/saveTraffic',
    method: 'post',
    data
  });
};
